import React from 'react';
import { Grid } from '../../node_modules/@material-ui/core';
import '../Loyalty.css';

const LoyaltyItemDisabled = props => {
  return (
    <div className='redeemable-container'>
      <Grid container spacing={0}>
        <div className='dimmed'>
          <div class='centered'>LOCKED</div>
          <img className='locked-icon' src='./lock.png' />

          <Grid item xs={12} className='redeemable-item'>
            <div className='redeemable-text'>{props.name}</div>
          </Grid>
        </div>
      </Grid>
    </div>
  );
};

export default LoyaltyItemDisabled;



// WEBPACK FOOTER //
// ./src/components/LoyaltyItemDisabled.js